import React, {ReactElement, useEffect, useState} from 'react';
import {
  Card,
  CardContent,
  createStyles,
  makeStyles,
  Theme,
  Typography
} from '@material-ui/core';
import {useTranslation} from 'react-i18next';
import NavRoutes from 'src/constants/route/NavRoutes';
import {APP, BLACK_COLOR, GET_8_PIXEL_BOX} from 'src/style/variable';
import BackNavigation from '../backNavigation/BackNavigation';
import MailCheckLogo from '@components/system/MyIcons/MailCheckLogo';
import LocationLogo from '@components/system/MyIcons/LocationLogo';

// styles
import './MailCheckStyles.scss';
import {VerifyGuarantorTokenPaymentServiceMapper} from '@shared/services/service-mappers/PaymentServiceMapper';
import {verifyGuarantorToken} from '@shared/services/Payment.service';
import CurrencyFormatter from '@components/system/CurrencyFormatter/CurrencyFormatter';
import {useSelector} from 'react-redux';
import PhoneNumberFormatter from '@components/system/PhoneNumberFormatter/PhoneNumberFormatter';

const {innerWidth: width} = window;
const isDesktop = width >= 1024 ? true : false;

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    loginButton: {
      padding: `${GET_8_PIXEL_BOX(1)} 0`,
      fontFamily: APP.FONT_FAMILY.BOLD,
      height: '2.7rem'
    },
    card: {
      borderRadius: 0,
      backgroundColor: theme.palette.primary.light,
      color: theme.palette.primary.contrastText,
      boxShadow: 'none'
    },
    cardPadding: {
      '& .MuiCardContent-root': {
        padding: 0
      },
      padding: 0
    },
    fieldText: {
      display: 'flex',
      color: BLACK_COLOR,
      paddingBottom: '0.5rem',
      justifyContent: 'flex-start',
      fontSize: '1.2rem'
    }
  })
);

const MailCheck = (props: any): ReactElement => {
  const classes = useStyles();
  const {history, match} = props;
  const {t} = useTranslation();
  const token = match.params.token;
  const [
    apiResponseData,
    setApiResponseData
  ] = useState<VerifyGuarantorTokenPaymentServiceMapper>();
  // const payAmountRedux = useSelector((state: any) => state.payments.payAmount);
  const paymentAmountDetails = useSelector(
    (state: any) => state.payments.paymentAmountDetails
  );
  const backNavigation = (): void => {
    history.push(`/${NavRoutes.PUBLIC.PAYMENTS_SECTION}/${token}`);
  };

  useEffect(() => {
    verifyGuarantorToken()
      .then(res => {
        if (res.data) {
          setApiResponseData(res.data);
        }
      })
      .catch(err => {
        if (err) {
          // FIXME : Route to invalid Payment route URL
          backNavigation();
        }
      });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const renderMailAddressCard = (): ReactElement => {
    return (
      <Typography
        className="mail-address-main-view input-header"
        component={'div'}>
        <div className="clinic-address-main-view ">
          <div>
            <LocationLogo />
          </div>
          <div className="address-view">
            <div className="clinic-name">
              {apiResponseData?.clinic_details?.name}
            </div>
            <div className="address">
              {apiResponseData?.clinic_details?.address}&nbsp;
              {apiResponseData?.clinic_details.address_line_2}&nbsp;
            </div>
            <div className="address">
              {apiResponseData?.clinic_details.city},&nbsp;
              {apiResponseData?.clinic_details.state},&nbsp;
              {apiResponseData?.clinic_details?.zip}
            </div>
            <div className="address">
              {apiResponseData?.clinic_details.phone ? (
                <PhoneNumberFormatter
                  value={apiResponseData.clinic_details.phone.toString()}
                />
              ) : (
                ''
              )}
            </div>
          </div>
        </div>
      </Typography>
    );
  };

  const payDetailsCard = (): ReactElement => {
    return (
      <Typography
        className="payment-card-details-main-view input-header"
        component={'div'}>
        <div className="headers-values-main-view ">
          <div className="headers-view">
            {' '}
            {t('PAYMENTS_LOGIN.CHECK_MAIL.PAY')}
          </div>
          <div className="values-view">
            {apiResponseData?.clinic_details?.name}
          </div>
        </div>
        <div className="headers-values-main-view " style={{paddingBottom: 0}}>
          <div className="headers-view">
            {t('PAYMENTS_LOGIN.CHECK_MAIL.PAY_AMOUNT_TEXT')}
          </div>
          <div className="values-view">
            <CurrencyFormatter
              value={
                (paymentAmountDetails?.dueAmount ?? 0) +
                (paymentAmountDetails?.copayAmount ?? 0) +
                (paymentAmountDetails?.chargeTypesAmount ?? 0)
              }
              displayType={'text'}
              thousandSeparator={true}
              prefix={'$'}
              ignoreRound={true}
              useSign={true}
            />
          </div>
        </div>
      </Typography>
    );
  };
  return (
    <div className="email-check-wrapper">
      <Card className={['email-check-content-wrap', classes.card].join(' ')}>
        <CardContent className={[classes.cardPadding, 'content'].join(' ')}>
          <div className="email-check-content-view">
            {!isDesktop && (
              <Typography className="details-view" component={'div'}>
                <BackNavigation navigateTo={backNavigation} />
              </Typography>
            )}
            {isDesktop && (
              <Typography className="details-view" component={'div'}>
                Mail Check
              </Typography>
            )}
            <Typography component={'div'}>
              <MailCheckLogo />
            </Typography>
            <Typography className="info-text input-header" component={'div'}>
              {t('PAYMENTS_LOGIN.CHECK_MAIL.TITLE')}
            </Typography>
            {renderMailAddressCard()}
            {payDetailsCard()}
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default MailCheck;
